import React, { useEffect, useRef } from 'react';

import { CLUSTER_HEADER_CATEGORY } from 'utils/constant';

import { formatNumber,formatSubPageText } from '../../../utils';

const CareerClusterHeaderTitle = ({
  subPageName,
  title,
  showJobsCount = false,
  noH1Tag = false,
  subPageTextSmall = true,
  jobTitleArticle,
  jobCount = '',
  getPageTitle,
  metadataH1,
}) => {
  const formattedSubPageName = formatSubPageText(subPageName, CLUSTER_HEADER_CATEGORY.CAREER);

  const TitleTag = noH1Tag ? 'p' : 'h1';
  const content = () => {
    if (subPageTextSmall) {
      return (
        <>
          <span className="title text-break">{`${title}`}</span>
          {formattedSubPageName && <span className="subPageName d-inline">{` ${formattedSubPageName}`}</span>}
        </>
      );
    }

    if (subPageName === 'best-states') return `Best states for ${jobTitleArticle?.toLowerCase()} ${title?.toLowerCase()}`;
    if (subPageName === 'best-cities') return `Best cities for ${jobTitleArticle.toLowerCase()} ${title.toLowerCase()}`;
    if (subPageName === 'what-they-do') return `What Does ${jobTitleArticle} ${title} Do?`;
    if (subPageName === 'how-to-become') return `How to become ${jobTitleArticle?.toLowerCase?.()} ${title?.toLowerCase?.()}`;
    if (subPageName === 'jobs') return `${title} Jobs Near Me`;
    if (subPageName === 'remote-jobs') return `${title} Remote Jobs`;
    if (subPageName === 'overview') return metadataH1;
    if (subPageName === 'certifications') return metadataH1;
    if (subPageName === 'faqs') return metadataH1;
    if (subPageName === 'compare') return metadataH1 || `${title} Comparisons`;
    if (subPageName === 'how-to-hire') return metadataH1;
    if (subPageName === 'sitemap-location-level') return metadataH1;
    if (subPageName === 'education' && metadataH1) return metadataH1;
    if (subPageName === 'salary') return `${title} salary`;
    if (subPageName === 'job-description' && metadataH1) return metadataH1;
    if (subPageName === 'career-path' && metadataH1) return metadataH1;
    if (subPageName === 'trends' && metadataH1) return metadataH1;
    return `${title} ${formattedSubPageName}`;
  };
  const isJobsPage = subPageName?.toLowerCase()?.includes('jobs');
  const hasJobs = jobCount > 0 && jobCount !== '';
  const titleRef = useRef(null);

    useEffect(() => {
      if (getPageTitle) {
        const text = titleRef?.current?.textContent;
        getPageTitle(subPageTextSmall ? title : text);
      }
    }, [getPageTitle]);

  return (
    <>
      {(isJobsPage && hasJobs) || showJobsCount ? (
        <div className="career-cluster-header-title career-title-only z-mt-16 z-mt-md-36 z-mb-36" ref={titleRef}>
          <TitleTag>{content()}</TitleTag>
          <span className="d-inline">{` - ${formatNumber(jobCount)} Jobs`}</span>
        </div>
      ) : (
        <TitleTag className="career-cluster-header-title career-title-only z-mt-16 z-mt-md-36 z-mb-36" ref={titleRef}>
          {content()}
        </TitleTag>
      )}
    </>
  );
};

export default CareerClusterHeaderTitle;
